<template>
  <v-alert outlined color="green" style="border-width: thick; color: #4CAF50 !important;" rounded elevation="1">
    <div class="mb-2">
      <b style="font-weight: bolder; color: black !important">継続ボーナス</b>
    </div>
    <div v-if="campaignUser.course.length > 0">
      <p style="color: black !important">
        週に1度以上記録・保存して、クローバーマーク
        <span>
          <img src="@/assets/continueBonus/cloverGreen.png" width="20px" style="margin-bottom:-7px">
        </span>
        を貯めましょう！<br/>
        {{continueBonus.incentive_requirement_week}}個以上貯めると、達成した時の賞品が＋100円になります！
      </p>
      <!--PC-->
      <v-row v-if="!isMobile" class="clover_point_row">
        <v-col v-for="(history) of continueBonusHistorys" :key="history.index" class="clover_point_col">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img v-if="history.continue_status===1" src="@/assets/continueBonus/cloverGreen.png" width="30px" v-bind="attrs" v-on="on">
              <img v-else src="@/assets/continueBonus/cloverGray.png" width="30px" v-bind="attrs" v-on="on">
            </template>
            <span>{{history.start}} ～ {{history.end}}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!--モバイル-->
      <v-row v-if="isMobile" class="clover_point_row">
        <v-col v-for="(history) of continueBonusHistorys" :key="history.index" class="clover_point_col_mobile">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img v-if="history.continue_status===1" src="@/assets/continueBonus/cloverGreen.png" width="23px" v-bind="attrs" v-on="on">
              <img v-else src="@/assets/continueBonus/cloverGray.png" width="23px" v-bind="attrs" v-on="on">
            </template>
            <span>{{history.start}} ～ {{history.end}}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <p style="color: black !important">
        食事バッチリ！アプリチャレンジコースを達成すると、<br/>
        継続ボーナス（達成賞 + 100円）の対象になります。
      </p>
    </div>
  </v-alert>
</template>

<script>

export default {
  name: 'ResultContinueBonus',
  data () {
    return {
      dailyImageList: [],
      participants: '',
      myRank: '',
      isCampaignPeriod: false,
      showAppStatusInfo: false
    }
  },
  props: ['campaignUser'],
  components: {
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    continueBonusHistorys () {
      return this.$store.getters.getContinueBonusHistorys
    },
    continueBonus () {
      return this.$store.getters.getContinueBonus
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    await this.$store.dispatch('setContinueBonusProcessorOutput', { campaignId: this.campaign.id, type: 'read' })
  }
}
</script>

<style scoped lang="scss">
.result_continuebonus_table {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
.clover_point_row {
  margin-left: 5px;
}
.clover_point_col {
  max-width:50px !important;
  min-width:50px !important;
  padding:0px 0px 0px 0px;
}
.clover_point_col_mobile {
  max-width:25px !important;
  min-width:30px !important;
  padding:0px 0px 0px 0px;
}
</style>
